module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-分享方式-复制链接.e137a.png";